import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  /**
   * Controls the visibility of the loader.
   * When true, the template should render the loading indicator.
   */
  isLoading: boolean = false;
}
